module.exports = __webpack_public_path__ + "static/img/noCover.d5f82305.jpg";